import { CellItem } from '../../components/core/DataTable/dataTable.types';

export interface Asset extends CellItem {
  id: number;
  groupId: number;
  parentAssetId: number;
  assetType: string;
  name: string;
  influxMachineName: string;
  useWithDashboards: boolean;
  grafanaFolderUId: string;
  hydraMachineNumber: string | null;
  loadPlanFromHydraMultiplicity: boolean | null;
  loadPlanFromHydra: boolean | null;
  loadPlanFromHydraMultiple: any | null;
  unitOverride: string | null;
}

// *** Forms ***
export interface AssetInputs {
  id?: number;
  groupId?: number;
  parentAssetId?: number;
  assetType: string;
  name: string;
  influxMachineName: string;
  useWithDashboards: boolean;
  grafanaFolderUId: string;
  hydraMachineNumber: string | null;
  loadPlanFromHydraMultiplicity: boolean | null;
  loadPlanFromHydra: boolean | null;
  loadPlanFromHydraMultiple: any | null;
  unitOverride: string | null;
}
export interface AssetDashboardSetting {
  id: number;
  assetId: number;
  timeAggregation: string;
}

// *** Requests ***

export interface AssetCreateRequest {
  groupId?: number;
  assetType: string;
  name: string;
  influxMachineName: string;
  parentAssetId: number | null;
  useWithDashboards: boolean;
  grafanaFolderUId: string;
  hydraMachineNumber: string | null;
  loadPlanFromHydraMultiplicity: boolean | null;
  loadPlanFromHydra: boolean | null;
  loadPlanFromHydraMultiple: any | null;
  unitOverride: string | null;
}

export interface AssetUpdateRequest {
  id: number;
  groupId?: number;
  assetType: string;
  name: string;
  influxMachineName: string;
  parentAssetId: number | null;
  useWithDashboards: boolean;
  grafanaFolderUId: string;
  hydraMachineNumber: string | null;
  loadPlanFromHydraMultiplicity: boolean | null;
  loadPlanFromHydra: boolean | null;
  loadPlanFromHydraMultiple: any | null;
  unitOverride: string | null;
}
export interface AddFolderToAsset {
  assetId: number;
  folderName: string;
}

export interface AddAssetToShiftRequest {
  id: number;
  shiftId: number;
}

export interface RemoveAssetFromShiftRequest {
  id: number;
  shiftId: number;
}

export interface AssetMainDashboardSetting {
  id: number;
  timeAggregation: string;
  showScrap: boolean;
  showActualCycleTime: boolean;
  showActualState: boolean;
  qtyLevelGreen: number;
  qtyLevelOrange: number;
  showOrangeLevelLine: boolean;
  showGreenLevelLine: boolean;
  taktTimeLineQty: number;
  note?: string;
  showHydraMachineNumber: boolean;
  showHydraOrderNumber: boolean;
  showHydraToolNumber: boolean;
  showHydraPartNumber: boolean;
  showHydraStatus: boolean;
}
export interface MainDashboardInputs {
  id: number;
  timeAggregation: string;
  note?: string;
  showScrap: boolean;
  showActualCycleTime: boolean;
  showActualState: boolean;
  qtyLevelGreen: number;
  qtyLevelOrange: number;
  showOrangeLevelLine: boolean;
  showGreenLevelLine: boolean;
  taktTimeLineQty: number;
  showHydraMachineNumber: boolean;
  showHydraOrderNumber: boolean;
  showHydraToolNumber: boolean;
  showHydraPartNumber: boolean;
  showHydraStatus: boolean;
}
export interface UpdateMainDashboardForAssetRequest {
  id: number;
  timeAggregation: string;
  showScrap: boolean;
  showActualCycleTime: boolean;
  showActualState: boolean;
  qtyLevelGreen: number;
  qtyLevelOrange: number;
  showOrangeLevelLine: boolean;
  showGreenLevelLine: boolean;
  taktTimeLineQty: number;
  note?: string;
  showHydraMachineNumber: boolean;
  showHydraOrderNumber: boolean;
  showHydraToolNumber: boolean;
  showHydraPartNumber: boolean;
  showHydraStatus: boolean;
}
export interface AssetType {
  code: string;
  name: string;
}

export interface AssetTreeView {
  id: number;
  influxMachineName: string;
  name: string;
  assetType: string;
  counters: any[];
  countersScrap: any[];
  processData: any[];
  cycleTimes: any[];
  states: any[];
  assetDescendants: AssetTreeView[];
}

export const assetTypes: AssetType[] = [
  {
    code: 'AssemblyLine',
    name: 'Assembly line',
  },
  {
    code: 'Block',
    name: 'Block',
  },
  {
    code: 'Module',
    name: 'Module',
  },
  {
    code: 'Station',
    name: 'Station',
  },
];

export enum AssetDetailTabValues {
  BASIC = '1',
  MAIN_DASHBOARD = '2',
  MONITORED_VALUES = '3',
  DASHBOARD = '4',
  PERFORMANCE_COMMENT_CATEGORY = '5',
}

export enum MonitoredPanelValues {
  MONITORED_COUNTER = 'panel1',
  MONITORED_COUNTER_SCRAP = 'panel2',
  MONITORED_CYCLE = 'panel3',
  MONITORED_PROCESS_DATA = 'panel4',
  MONITORED_STATE = 'panel5',
}
